import { Permissions, Adviser } from 'utils/user/types';
import { Nullable } from 'utils/types';

class User {
  id: number;
  name: string;
  role: Nullable<string>;
  permissions: Nullable<Permissions>;
  email: string;
  advisers: Nullable<Adviser[]>;

  constructor(
    id: number,
    name: string,
    role: Nullable<string>,
    permissions: Nullable<Permissions>,
    email: string,
    advisers: Nullable<Adviser[]>,
  ) {
    this.id = id;
    this.name = name;
    this.role = role;
    this.permissions = permissions;
    this.email = email;
    this.advisers = advisers;
  }
}

export default User;
